package kz.dentalcrm.app.screens.appointments.add.mvi

import kz.dentalcrm.app.core.base.ViewSideEffect

sealed interface AddAppointmentViewSideEffect : ViewSideEffect {

    data object NavigateBack : AddAppointmentViewSideEffect
}